import * as React from "react";


export default class Modal extends React.Component {
	constructor(props) {
		super(props);
		this.MODAL_OPEN_CLASS = "modal-open";
		this.closeModal = this.closeModal.bind(this);
		this.ok = this.ok.bind(this);
	}


	componentDidMount() {
		document.body.classList.add(this.MODAL_OPEN_CLASS);
	}


	componentWillUnmount() {
		document.body.classList.remove(this.MODAL_OPEN_CLASS);
	}

	closeModal() {
		this.props.close();
	}

	ok() {
		this.props.ok();
	}


	render() {

		return (
			<div className="modal fade show" id="modalDefault" tabIndex="-1" role="dialog" style={{
				display: this.props.open ? "block" : "none",
				paddingRight: "17px"
			}}>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 className="modal-title">{this.props.title}</h4>
							<button className="close" type="button" aria-label="Close" onClick={this.closeModal}><span aria-hidden="true">×</span></button>
						</div>
						<div className="modal-body">
							{this.props.children}
						</div>
						<div className="modal-footer">
							<button className="btn btn-white btn-sm" type="button" onClick={this.closeModal} >Cancel</button>
							<button className="btn btn-primary btn-sm" type="button" onClick={this.ok}>Ok</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}